<template>
  <f7-page name="garage">
    <bc-navbar></bc-navbar>
    <!-- Loader -->
    <div v-if="loading" class="loader">
      <looping-rhombuses-spinner
        :animation-duration="2500"
        :rhombus-size="15"
        color="#f9f300"
      />
    </div>
    <div class="content-wrapper">
      <h2 class="page_title">
        My Contacts
      </h2>
      <contact-item v-for="contact in contactData" :key="contact.id" :contact="contact" :isDemo="isDemoUser"></contact-item>
    </div>
  </f7-page>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import ContactItem from '../../components/contact/contact.component.vue'
import { LoopingRhombusesSpinner } from 'epic-spinners'
export default {
  components: {
    'contact-item': ContactItem,
    LoopingRhombusesSpinner
  },
  methods: {
    ...mapActions({
      getContacts: 'contact/getContacts'
    })
  },
  computed: {
    ...mapGetters({contactData: 'contact/contactData'}),
    ...mapState({
      isDemoUser: state => state.editUserProfile.customerUser.isDemoUser
    })
  },
  mounted () {
    this.loading = true
    this.getContacts().finally(() => {
      this.loading = false
    })
  },
  data () {
    return {
      loading: false
    }
  }
}
</script>

<style scoped>
.content-wrapper {
  width: 100%;
  box-sizing: border-box;
  padding: 0 5%;
}
.loader {
  position: fixed;
  z-index: 1;
  background: rgb(255, 255, 255);
}
.page_title{
  margin: 0 0 15px 0;
}
</style>



// WEBPACK FOOTER //
// contact.vue?510d857d